const CoreError = {
  None: 'None',
  NotAuthorised: 'NotAuthorised',
  BadOutput: 'BadOutput',
  NoData: 'NoData',
}

export { CoreError }
